// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"487":"myOrder","962":"home"}[chunkId] || chunkId) + "." + {"487":"37d0d730","648":"2c5f8a92","720":"f8d1c388","962":"fd73e808"}[chunkId] + ".js";
};